import React, { useState, useEffect, useRef  } from 'react';
import {
  Autocomplete,Button,TextField, Box, List, ListItem, ListItemText,IconButton,Snackbar, Alert,
   Grid, Dialog,DialogActions,DialogContent,DialogTitle,Typography } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import './mymaps.css';
import BusCheckboxes from './BusCheckboxes';
import IconSelector from '../commons/IconSelector';
import ColorPicker from '../buses/ColorPicker'; // Importa el ColorPicker


const Mymaps = () => {
  const [buses, setBuses] = useState([]);
  const [puntosInteres, setPuntosInteres] = useState([]);
  const [poligonos, setPoligonos] = useState([]);
  const [selectedElements, setSelectedElements] = useState([]);
  const [filters, setFilters] = useState({
    punto: '',
    linea: '',
    poligono: '',
  });

  const [map, setMap] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [saveMapOpen, setSaveMapOpen] = useState(false); // Para el estado del diálogo de guardar mapa
  const [mapName, setMapName] = useState(''); // Para el nombre del mapa
  const [iconDialogOpen, setIconDialogOpen] = useState(false);
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [selectedPoint, setSelectedPoint] = useState(null); // Para almacenar la coordenada del punto seleccionado
  const [pointName, setPointName] = useState(''); // Para almacenar el nombre del punto
  const [pointDialogOpen, setPointDialogOpen] = useState(false); // Para controlar la apertura del pop-up
  const [isDrawing, setIsDrawing] = useState(false); // Estado para controlar si estamos dibujando
  const [polygonPoints, setPolygonPoints] = useState([]); // Almacena los puntos del polígono
  const [polygonDialogOpen, setPolygonDialogOpen] = useState(false); // Controla el diálogo de guardar polígono
  const [nombreZona, setNombreZona] = useState(''); // Nombre de la zona
  const [selectedColor, setSelectedColor] = useState('#FF0000'); // Color seleccionado
  const polygonRef = useRef(null); // Referencia al polígono en el mapa
  const previouslyRenderedElements = useRef([]);
  const [sequenceOrder, setSequenceOrder] = useState(1);
  const [layersVisibility, setLayersVisibility] = useState({});
  const [showLayersPanel, setShowLayersPanel] = useState(false);
  const [saveMarkersDialogOpen, setSaveMarkersDialogOpen] = useState(false);
  const [newListName, setNewListName] = useState('');
  const [combinedMarkers, setCombinedMarkers] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [deletedMarkers, setDeletedMarkers] = useState(() => {
  // Cargar marcadores eliminados del localStorage al iniciar
  const saved = localStorage.getItem('deletedMarkers');
  return saved ? JSON.parse(saved) : [];
});
const [searchAddress, setSearchAddress] = useState('');
const [addressDialogOpen, setAddressDialogOpen] = useState(false);
const [foundLocation, setFoundLocation] = useState(null);
const [direccion, setDireccion] = useState('');
const [localidad, setLocalidad] = useState('');
const [icono, setIcono] = useState('');
const [temporalMarkers, setTemporalMarkers] = useState([]);
const [markerToEdit, setMarkerToEdit] = useState(null);
const [deletedMarkersCount, setDeletedMarkersCount] = useState(() => {
  const saved = localStorage.getItem('deletedMarkers');
  return saved ? JSON.parse(saved).length : 0;
});
  

  useEffect(() => {
    if (window.google) {
      initMap();
    } else {
      const script = document.createElement('script');
      script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyD1Nl9yulU0jgl6VRGkK89neIalMrblrws&callback=initMap";
      script.async = true;
      document.body.appendChild(script);
      window.initMap = initMap;
    }
  }, []);

//carga los datos del filtro
  useEffect(() => {
  const fetchData = async () => {
    try {
      // Manejo simplificado de puntos de interés
      if (filters.punto) {
        const response = await axios.get(`https://mapa.ne3publicidad.com.ar/api/api/getPuntosInteres/${filters.punto}`);
        setPuntosInteres(response.data); // Guarda el array directamente
      } else {
        setPuntosInteres([]);
      }

      // Manejo de polígonos (se mantiene igual)
      if (filters.poligono) {
        const response = await axios.get(`https://mapa.ne3publicidad.com.ar/api/api/getPolygonPoints/${filters.poligono}`);
        const data = response.data;
        const groupedData = data.reduce((acc, poligono) => {
          if (!acc[poligono.nombre_zona]) {
            acc[poligono.nombre_zona] = [];
          }
          acc[poligono.nombre_zona].push(poligono);
          return acc;
        }, {});
        setPoligonos(groupedData);
      } else {
        setPoligonos({});
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setAlertMessage("Error al cargar los datos");
      setAlertSeverity("error");
      setAlertOpen(true);
    }
  };

  fetchData();
}, [filters]);

  const initMap = () => {
    const mapInstance = new window.google.maps.Map(document.getElementById('map'), {
      center: { lat: -34.603722, lng: -58.381592 },  // Coordenadas del Obelisco, centro de Buenos Aires
      zoom: 12,
    });
    setMap(mapInstance);
  };

  //funcion para limpiar el localStorage de marcadores eliminados 
  
useEffect(() => {
  const saved = localStorage.getItem('deletedMarkers');
  if (saved) {
    const parsed = JSON.parse(saved);
    setDeletedMarkers(parsed);
    setDeletedMarkersCount(parsed.length);
  }
}, []); // <- Array de dependencias vacío = solo al montar

// 2 Efecto para sincronizar cambios (se ejecuta cuando deletedMarkers cambie)
useEffect(() => {
  if (deletedMarkers.length > 0) {
    localStorage.setItem('deletedMarkers', JSON.stringify(deletedMarkers));
    setDeletedMarkersCount(deletedMarkers.length);
  } else {
    localStorage.removeItem('deletedMarkers');
    setDeletedMarkersCount(0);
  }
}, [deletedMarkers]); // <- Se ejecuta cuando deletedMarkers cambia

  const handleClearDeletedMarkers = () => {
  clearDeletedMarkers();
  setAlertMessage('Marcadores eliminados limpiados correctamente');
  setAlertSeverity('success');
  setAlertOpen(true);
};

  //metodo para geocoding de inputs

  const handleSearchAddress = async () => {
  if (!searchAddress.trim()) {
    setAlertMessage('Por favor ingresa una dirección');
    setAlertSeverity('warning');
    setAlertOpen(true);
    return;
  }

  try {
    const response = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json`,
      {
        params: {
          address: searchAddress,
          key: 'AIzaSyDhV1-TmsTWBVC3TMbc_ATcflMHSC2Y9Wo',
        },
      }
    );

    if (response.data.status === 'OK') {
      const location = response.data.results[0].geometry.location;
      const addressComponents = response.data.results[0].address_components;
      
      const localidad = addressComponents.find(component => 
        component.types.includes('locality')
      )?.long_name || '';

      // Guardar la información del marcador temporalmente
      setMarkerToEdit({
        lat: location.lat,
        lng: location.lng,
        direccion: searchAddress,
        localidad,
        nombre: `Marcador ${temporalMarkers.length + 1}`,
        temporalId: Date.now() // ID único
      });

      // Abrir automáticamente el diálogo de íconos
      setIconDialogOpen(true);
      
      setSearchAddress('');
    } else {
      throw new Error('No se encontró la dirección');
    }
  } catch (error) {
    console.error('Error al buscar dirección:', error);
    setAlertMessage('Error al buscar dirección: ' + error.message);
    setAlertSeverity('error');
    setAlertOpen(true);
  }
};

//añade marcador en el mapa para cuando se agrega por direccion

const handleAddTemporalMarker = () => {
  if (!foundLocation || !icono) {
    setAlertMessage('Por favor selecciona un ícono');
    setAlertSeverity('warning');
    setAlertOpen(true);
    return;
  }

  const newMarker = {
    ...foundLocation,
    icono,
    nombre: `Marcador ${temporalMarkers.length + 1}`
  };

  setTemporalMarkers([...temporalMarkers, newMarker]);
  
  // Crear el marcador en el mapa
  const marker = new window.google.maps.Marker({
    position: { lat: newMarker.lat, lng: newMarker.lng },
    map,
    title: newMarker.nombre,
    icon: newMarker.icono,
  });

  // Agregar a selectedElements como temporal
  setSelectedElements(prev => [
    ...prev,
    {
      nombre: `Temporal-${Date.now()}`,
      type: 'punto',
      data: [newMarker],
      markers: [{ ...newMarker, mapMarker: marker }],
      isTemporal: true
    }
  ]);

  // Limpiar estados
  setSearchAddress('');
  setFoundLocation(null);
  setIcono('');
  setAddressDialogOpen(false);
  
  setAlertMessage('Marcador temporal añadido');
  setAlertSeverity('success');
  setAlertOpen(true);
};

//guarda los marcadores añadidos por direccion 

const handleSaveTemporalMarkers = async () => {
  if (!newListName.trim()) {
    setAlertMessage('Por favor ingresa un nombre para la lista');
    setAlertSeverity('warning');
    setAlertOpen(true);
    return;
  }

  try {
    // Filtrar marcadores temporales únicos
    const uniqueMarkers = temporalMarkers.reduce((acc, current) => {
      const x = acc.find(item => 
        item.lat === current.lat && item.lng === current.lng
      );
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);

    const response = await axios.post('https://mapa.ne3publicidad.com.ar/api/api/uploadPuntosInteres', {
      data: uniqueMarkers,
      nombre: newListName,
      icono: uniqueMarkers[0]?.icono || 'https://maps.google.com/mapfiles/kml/pal2/icon48.png'
    });

    // Actualizar el estado con los marcadores guardados
    setSelectedElements(prev => [
      ...prev.filter(el => !el.isTemporal),
      {
        nombre: newListName,
        type: 'punto',
        data: uniqueMarkers,
        markers: uniqueMarkers.map(marker => ({
          ...marker,
          mapMarker: new window.google.maps.Marker({
            position: { lat: marker.lat, lng: marker.lng },
            map,
            title: marker.nombre,
            icon: marker.icono,
          })
        }))
      }
    ]);

    // Limpiar temporales
    setTemporalMarkers([]);
    setNewListName('');
    
    setAlertMessage('Marcadores guardados exitosamente');
    setAlertSeverity('success');
    setAlertOpen(true);
  } catch (error) {
    console.error('Error al guardar marcadores:', error);
    setAlertMessage('Error al guardar marcadores: ' + error.message);
    setAlertSeverity('error');
    setAlertOpen(true);
  }
};

  // Efecto para sincronizar con localStorage cuando cambia deletedMarkers
  useEffect(() => {
    if (deletedMarkers.length > 0) {
      localStorage.setItem('deletedMarkers', JSON.stringify(deletedMarkers));
    } else {
      localStorage.removeItem('deletedMarkers');
    }
  }, [deletedMarkers]);

  //dialog seleccion de punto de interes 
 

  const closeIconDialog = () => {
    setIconDialogOpen(false);
  };

 const handleSelectIcon = (icon) => {
  if (markerToEdit) {
    const newMarker = {
      ...markerToEdit,
      icono: icon,
      nombre: `Marcador ${temporalMarkers.length + 1}`
    };

    // Crear el marcador en el mapa
    const marker = new window.google.maps.Marker({
      position: { lat: newMarker.lat, lng: newMarker.lng },
      map,
      title: newMarker.nombre,
      icon: newMarker.icono,
    });

    // Permitir eliminar el marcador con clic derecho
    marker.addListener('rightclick', () => {
      marker.setMap(null);
      setTemporalMarkers(prev => prev.filter(m => 
        m.lat !== newMarker.lat || m.lng !== newMarker.lng
      ));
    });

    // Agregar a la lista de temporales
    setTemporalMarkers([...temporalMarkers, newMarker]);
    
    // Agregar al estado de elementos seleccionados
    setSelectedElements(prev => [
      ...prev,
      {
        nombre: `Temporal-${Date.now()}`,
        type: 'punto',
        data: [newMarker],
        markers: [{ ...newMarker, mapMarker: marker }],
        isTemporal: true
      }
    ]);

    setAlertMessage('Marcador añadido');
    setAlertSeverity('success');
    setAlertOpen(true);
  }
  
  setIconDialogOpen(false);
  setMarkerToEdit(null);
};

  //metodo click en el mapa para agregar el punto 
  useEffect(() => {
    if (map) {
      // Evento de clic en el mapa
      window.google.maps.event.addListener(map, 'dblclick', (event) => {
        const latLng = event.latLng;
        setSelectedPoint(latLng); // Guardar la coordenada del clic
        setIconDialogOpen(true); // Abrir el diálogo de selección de ícono
      });
    }
  }, [map]); // Dependencia: map
  
  //metodo para guardar el punto haciendo click en el mapa 
  const handleAddPoint = async () => {
    if (selectedPoint && pointName && selectedIcon) {
      try {
        // Obtener la dirección y localidad usando Geocoding
        const geocodeResponse = await axios.get(
          `https://maps.googleapis.com/maps/api/geocode/json`,
          {
            params: {
              latlng: `${selectedPoint.lat()},${selectedPoint.lng()}`,
              key: 'AIzaSyDhV1-TmsTWBVC3TMbc_ATcflMHSC2Y9Wo', // Tu clave de API de Google Maps
            },
          }
        );
  
        if (geocodeResponse.data.status !== 'OK') {
          throw new Error('No se pudo obtener la dirección desde las coordenadas');
        }
  
        // Extraer la dirección y localidad de la respuesta
        const addressComponents = geocodeResponse.data.results[0].address_components;
        const direccion = geocodeResponse.data.results[0].formatted_address; // Dirección completa
        const localidad = addressComponents.find((component) =>
          component.types.includes('locality')
        )?.long_name; // Nombre de la localidad
  
        if (!direccion || !localidad) {
          throw new Error('No se pudo obtener la dirección o localidad');
        }
  
        // Crear el objeto del punto de interés
        const newPoint = {
          lat: selectedPoint.lat(),
          lng: selectedPoint.lng(),
          icono: selectedIcon,
          nombre: pointName,
          direccion,
          localidad,
        };
  
        // Crear el marcador en el mapa
        const marker = new window.google.maps.Marker({
          position: { lat: newPoint.lat, lng: newPoint.lng },
          map,
          title: newPoint.nombre,
          icon: newPoint.icono,
        });
        
       
        
  
        // Enviar el punto al backend
        const response = await axios.post('https://mapa.ne3publicidad.com.ar/api/api/uploadPuntosInteres', {
          data: [
            {
              lat: newPoint.lat,
              lng: newPoint.lng,
              direccion: newPoint.direccion,
              localidad: newPoint.localidad,
            },
          ],
          nombre: newPoint.nombre,
          icono: newPoint.icono,
        });
  
        // Mostrar mensaje de éxito
        setAlertMessage('Punto de interés guardado exitosamente');
        setAlertSeverity('success');
        setAlertOpen(true);
  
        // Agregar el nuevo punto a selectedElements
        setSelectedElements((prevElements) => [
          ...prevElements,
          {
            nombre: newPoint.nombre,
            type: 'punto',
            data: [newPoint],
            marker: marker,
          },
        ]);
  
        // Cerrar el diálogo y limpiar el estado
        setPointDialogOpen(false);
        setPointName('');
        setSelectedIcon(null);
      } catch (error) {
        console.error('Error al guardar el punto de interés:', error);
        setAlertMessage('Error al guardar el punto de interés: ' + error.message);
        setAlertSeverity('error');
        setAlertOpen(true);
      }
    } else {
      setAlertMessage('Por favor, seleccione un ícono y asigne un nombre al punto');
      setAlertSeverity('warning');
      setAlertOpen(true);
    }
  };

  // Función para alternar entre "Crear poligono" y "Finalizar poligono"
  const toggleDrawing = () => {
    if (isDrawing) {
      // Si estamos finalizando, abrimos el diálogo para guardar el polígono
      setPolygonDialogOpen(true);
    } else {
      // Si estamos comenzando, limpiamos completamente
      setPolygonPoints([]);
      if (polygonRef.current) {
        polygonRef.current.setMap(null);
        polygonRef.current = null;
      }
    }
    setIsDrawing(!isDrawing);
  };

  // Función para guardar el polígono en el backend
  const handleSavePolygon = async () => {
    if (!nombreZona || polygonPoints.length === 0) {
      setAlertMessage('Por favor, ingresa un nombre y asegúrate de haber creado un polígono.');
      setAlertSeverity('warning');
      setAlertOpen(true);
      return;
    }
  
    try {
      const polygonData = polygonPoints.map((punto) => ({
        nombre_zona: nombreZona,
        lat: punto.lat,
        lng: punto.lng,
        color: selectedColor,
      }));
  
      const response = await axios.post('https://mapa.ne3publicidad.com.ar/api/api/savePolygon', {
        nombre_zona: nombreZona,
        puntos: polygonData,
        color: selectedColor,
      });
  
      if (response.status === 200) {
        // Eliminar el polígono temporal
        if (polygonRef.current) {
          polygonRef.current.setMap(null);
          polygonRef.current = null;
        }
  
        // Agregar el polígono a selectedElements para que se renderice normalmente
        setSelectedElements((prevElements) => [
          ...prevElements,
          {
            nombre: nombreZona,
            type: 'polygon',
            data: polygonData,
            color: selectedColor,
          },
        ]);
  
        // Mostrar mensaje de éxito
        setAlertMessage('Forma guardada exitosamente');
        setAlertSeverity('success');
        setAlertOpen(true);
  
        // Limpiar estado
        setPolygonDialogOpen(false);
        setNombreZona('');
        setSelectedColor('#FF0000');
        setIsDrawing(false);
        setPolygonPoints([]);
      }
    } catch (error) {
      console.error('Error al guardar la Forma:', error);
      setAlertMessage('Error al guardar la Forma');
      setAlertSeverity('error');
      setAlertOpen(true);
    }
  };

  // Efecto para manejar la creación del polígono en el mapa
  useEffect(() => {
    if (map && isDrawing) {
      // Evento de clic en el mapa para agregar puntos al polígono
      const clickListener = window.google.maps.event.addListener(map, 'click', (event) => {
        setPolygonPoints((prevPoints) => [...prevPoints, { lat: event.latLng.lat(), lng: event.latLng.lng() }]);
      });

      // Limpiar el listener cuando se desactiva el dibujo
      return () => {
        window.google.maps.event.removeListener(clickListener);
      };
    }
  }, [map, isDrawing]);

  

  // Efecto para manejar el polígono temporal durante el dibujo
useEffect(() => {
  if (!map || !isDrawing) return;

  // Limpiar polígono anterior si existe
  if (polygonRef.current) {
    polygonRef.current.setMap(null);
    polygonRef.current = null;
  }

  // Solo crear nuevo polígono si hay puntos
  if (polygonPoints.length > 0) {
    const newPolygon = new window.google.maps.Polygon({
      paths: polygonPoints.map((p) => ({ lat: p.lat, lng: p.lng })),
      strokeColor: selectedColor,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: selectedColor,
      fillOpacity: 0.35,
      editable: true,
      map,
    });

    // Actualizar puntos cuando se edita
    const updatePolygonState = () => {
      const currentPaths = newPolygon
        .getPath()
        .getArray()
        .map((latLng) => ({ lat: latLng.lat(), lng: latLng.lng() }));
      setPolygonPoints(currentPaths);
    };

    // Listeners para edición
    newPolygon.getPath().addListener('insert_at', updatePolygonState);
    newPolygon.getPath().addListener('set_at', updatePolygonState);
    newPolygon.getPath().addListener('remove_at', updatePolygonState);

    polygonRef.current = newPolygon;
  }

  return () => {
    if (polygonRef.current) {
      window.google.maps.event.clearInstanceListeners(polygonRef.current);
    }
  };
}, [map, isDrawing, polygonPoints, selectedColor]);

  // Efecto para actualizar el color del polígono
  useEffect(() => {
    if (polygonRef.current) {
      // Actualiza el color del polígono
      polygonRef.current.setOptions({
        strokeColor: selectedColor,
        fillColor: selectedColor,
      });
    }
  }, [selectedColor]);

  //Funcion para cancelar y limpiar el poligono 

  const handleCancelPolygon = () => {
    setPolygonDialogOpen(false); // Cierra el diálogo
    setIsDrawing(false); // Desactiva el modo de dibujo
    setPolygonPoints([]); // Limpia los puntos del polígono
    setNombreZona(''); // Limpia el nombre de la zona
    setSelectedColor('#FF0000'); // Restablece el color
  
    // Elimina el polígono del mapa
    if (polygonRef.current) {
      polygonRef.current.setMap(null);
      polygonRef.current = null;
    }
  };

  //metodo para eliminar por click marcadores del mapa individualmente
 const handleRemoveIndividualMarker = (listName, markerId) => {
  setIsEditing(true);
  
  // Encontrar el elemento en selectedElements
  setSelectedElements(prevElements => {
    return prevElements.map(element => {
      if (element.nombre === listName && element.type === 'punto') {
        // Encontrar y eliminar el marcador del mapa
        const markerToRemove = element.markers?.find(m => 
          m.id === markerId || m.nombre === markerId
        );
        if (markerToRemove?.mapMarker) {
          markerToRemove.mapMarker.setMap(null);
        }

        // Filtrar el marcador de los datos
        const updatedData = element.data.filter((punto, idx) => 
          punto.id !== markerId && idx !== markerId
        );

        // Filtrar de los markers también
        const updatedMarkers = element.markers?.filter(m => 
          m.id !== markerId && m !== markerId
        );

        return {
          ...element,
          data: updatedData,
          markers: updatedMarkers
        };
      }
      return element;
    });
  });

  // Agregar el ID a la lista de eliminados
  addToDeletedMarkers(markerId);
  
  setIsEditing(false);
};
  
// dialog para guardar las listas combinadas 
const handleOpenSaveMarkersDialog = () => {
  const allMarkers = selectedElements
    .filter(el => el.type === 'punto' && el.data)
    .flatMap(element => 
      element.data.filter(punto => 
        punto && !isNaN(punto.lat) && !isNaN(punto.lng)
      )
    );

  if (allMarkers.length === 0) {
    setAlertMessage('No hay marcadores válidos para guardar');
    setAlertSeverity('warning');
    setAlertOpen(true);
    return;
  }

  setCombinedMarkers(allMarkers);
  setSaveMarkersDialogOpen(true);
};

const handleSaveCombinedMarkers = async () => {
  if (!newListName.trim()) {
    setAlertMessage('Por favor ingresa un nombre para la lista');
    setAlertSeverity('warning');
    setAlertOpen(true);
    return;
  }

  try {
    // 1. Filtrar marcadores eliminados primero (si los hay)
    const filteredMarkers = combinedMarkers
      .filter(marker => !deletedMarkers.includes(marker.id || marker.nombre));

    // 2. Agrupar marcadores por icono para preservarlos
    const markersByIcon = filteredMarkers.reduce((acc, marker) => {
      const iconKey = marker.icono || 'default';
      if (!acc[iconKey]) {
        acc[iconKey] = [];
      }
      acc[iconKey].push(marker);
      return acc;
    }, {});

    // 3. Guardar cada grupo con su icono correspondiente
    await Promise.all(
      Object.entries(markersByIcon).map(async ([icon, markers]) => {
        await axios.post('https://mapa.ne3publicidad.com.ar/api/api/uploadPuntosInteres', {
          data: markers.map(marker => ({
            ...marker,
            nombre: newListName
          })),
          nombre: newListName,
          icono: icon !== 'default' ? icon : 'https://maps.google.com/mapfiles/kml/pal2/icon11.png'
        });
      })
    );

    // 4. Limpiar marcadores eliminados
    clearDeletedMarkers();
    
    // 5. Cerrar diálogo y abrir el de guardar mapa
    setSaveMarkersDialogOpen(false);
    setSaveMapOpen(true);
    
  } catch (error) {
    console.error('Error al guardar:', error);
    setAlertMessage(error.response?.data?.message || 'Error al guardar la lista');
    setAlertSeverity('error');
    setAlertOpen(true);
  }
};

//metodo para añadir marcadores eliminados a local storage 
const addToDeletedMarkers = (markerId) => {
  setDeletedMarkers(prev => {
    const updated = [...prev, markerId];
    localStorage.setItem('deletedMarkers', JSON.stringify(updated));
    return updated;
  });
  
  // Forzar re-renderizado
  setSelectedElements(prev => [...prev]);
};

const clearDeletedMarkers = () => {
  setDeletedMarkers([]);
  localStorage.removeItem('deletedMarkers');
  setDeletedMarkersCount(0);
  
  // Forzar re-renderizado de los elementos
  setSelectedElements(prev => [...prev]);
};

 //metodo para agrupar por nombre en las listas 11
 const handleSelectElement = (nombre, data, type, color) => {
  setSelectedElements(prevElements => {
    // Si estamos eliminando (data vacío)
    if (!data || data.length === 0) {
      // Eliminar por nombre exacto y tipo
      return prevElements.filter(el => el.nombre !== nombre || el.type !== type);
    }

    // Si estamos agregando
    const existingIndex = prevElements.findIndex(el => el.nombre === nombre && el.type === type);
    
    if (existingIndex >= 0) {
      // Si ya existe, lo eliminamos primero (toggle)
      const newElements = [...prevElements];
      newElements.splice(existingIndex, 1);
      return newElements;
    }

    // Crear nuevo elemento
    return [
      ...prevElements,
      {
        nombre,
        type,
        data: data.map(point => ({
          ...point,
          lat: parseFloat(point.lat),
          lng: parseFloat(point.lng)
        })),
        color: data[0]?.color || color || '#FF0000'
      }
    ];
  });
};
 //metodo renderizado de elementos 
useEffect(() => {
  if (!map) return;

  // Limpiar elementos eliminados
  previouslyRenderedElements.current.forEach(prevEl => {
    const stillExists = selectedElements.some(currentEl => 
      currentEl.nombre === prevEl.nombre && currentEl.type === prevEl.type
    );
    
    if (!stillExists) {
      // Eliminar del mapa
      if (prevEl.markers) {
        if (Array.isArray(prevEl.markers)) {
          prevEl.markers.forEach(m => m?.mapMarker?.setMap(null));
        } else {
          prevEl.markers.mapMarker?.setMap(null);
        }
      }
      if (prevEl.polyline) {
        if (Array.isArray(prevEl.polyline)) {
          prevEl.polyline.forEach(p => p?.setMap(null));
        } else {
          prevEl.polyline?.setMap(null);
        }
      }
      if (prevEl.polygon) {
        prevEl.polygon?.setMap(null);
      }
    }
  });

  // Renderizar nuevos elementos y actualizar visibilidad
  const currentRendered = [];
  selectedElements.forEach(element => {
    try {
      // Verificar si el elemento ya estaba renderizado
      const alreadyRendered = previouslyRenderedElements.current.some(
        el => el.nombre === element.nombre && el.type === element.type
      );

      // Determinar si la capa está visible (por defecto true si no está definido)
      const layerKey = `${element.type}-${element.nombre}`;
      const isVisible = layersVisibility[layerKey] !== false;

      if (!alreadyRendered) {
        // Manejo de marcadores
        if (element.type === 'punto' && element.data) {
          element.markers = element.data
            .filter(punto => !deletedMarkers.includes(punto.id || punto.nombre)) // Excluir eliminados
            .map((punto, index) => {
              // Verifica que el punto tenga coordenadas válidas
              if (!punto || isNaN(punto.lat) || isNaN(punto.lng)) {
                console.warn('Punto inválido:', punto);
                return null;
              }

              const marker = new window.google.maps.Marker({
                position: { 
                  lat: parseFloat(punto.lat), 
                  lng: parseFloat(punto.lng) 
                },
                map: isVisible ? map : null,
                title: punto.nombre || 'Sin nombre',
                icon: punto.icono || null,
              });

              // Agregar evento de clic derecho para eliminar todo el grupo
              marker.addListener('rightclick', () => {
                handleRemoveElement(element.nombre, element.type);
              });

              // Evento para eliminar individualmente (clic izquierdo)
              marker.addListener('click', () => {
                handleRemoveIndividualMarker(element.nombre, punto.id || index);
              });

              return { ...punto, mapMarker: marker };
            }).filter(Boolean); // Filtra marcadores nulos
        }

        // Manejo de polilíneas (buses)
        else if (element.type === 'bus' && element.data) {
          const routes = element.data.reduce((acc, point) => {
            const lineKey = point.linea || element.nombre;
            if (!acc[lineKey]) {
              acc[lineKey] = {
                points: [],
                color: point.color || element.color || '#FF0000'
              };
            }
            acc[lineKey].points.push(point);
            return acc;
          }, {});

          element.polyline = Object.entries(routes).map(([linea, routeData]) => {
            // Ordenar y limpiar puntos
            const validPoints = routeData.points
              .sort((a, b) => a.sequence_order - b.sequence_order)
              .map(point => ({
                lat: point.lat,
                lng: point.lng
              }));

            // Crear polilínea
            const polyline = new window.google.maps.Polyline({
              path: validPoints,
              geodesic: true,
              strokeColor: routeData.color,
              strokeOpacity: 1.0,
              strokeWeight: 4,
              map: isVisible ? map : null,
              zIndex: 1000
            });

            // Agregar evento de clic derecho para eliminar
            polyline.addListener('rightclick', () => {
              handleRemoveElement(element.nombre, element.type);
            });

            return polyline;
          });
        }

        // Manejo de polígonos
        else if (element.type === 'polygon' && element.data) {
          const polygonPath = element.data.map(p => ({
            lat: p.lat,
            lng: p.lng,
          }));

          if (polygonPath.length >= 3) {
            const polygon = new window.google.maps.Polygon({
              paths: polygonPath,
              strokeColor: element.data[0]?.color || '#FF0000',
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: element.data[0]?.color || '#FF0000',
              fillOpacity: 0.35,
              map: isVisible ? map : null,
            });

            // Agregar evento de clic derecho para eliminar
            polygon.addListener('rightclick', () => {
              handleRemoveElement(element.nombre, element.type);
            });

            element.polygon = polygon;
          }
        }
      } else {
        // Actualizar visibilidad de elementos existentes
        if (element.markers) {
          if (Array.isArray(element.markers)) {
            element.markers.forEach(m => {
              if (m && m.mapMarker) {
                m.mapMarker.setMap(isVisible ? map : null);
              }
            });
          } else {
            element.markers.mapMarker.setMap(isVisible ? map : null);
          }
        }
        if (element.polyline) {
          if (Array.isArray(element.polyline)) {
            element.polyline.forEach(p => p.setMap(isVisible ? map : null));
          } else {
            element.polyline.setMap(isVisible ? map : null);
          }
        }
        if (element.polygon) {
          element.polygon.setMap(isVisible ? map : null);
        }
      }

      currentRendered.push({
        nombre: element.nombre,
        type: element.type,
        markers: element.markers,
        polyline: element.polyline,
        polygon: element.polygon
      });
    } catch (error) {
      console.error(`Error rendering ${element.type} element:`, error);
      setAlertMessage(`Error al renderizar ${element.type}: ${error.message}`);
      setAlertSeverity('error');
      setAlertOpen(true);
    }
  });

  previouslyRenderedElements.current = currentRendered;

  // Limpieza al desmontar
  return () => {
    currentRendered.forEach(element => {
      if (element.markers) {
        if (Array.isArray(element.markers)) {
          element.markers.forEach(m => {
            if (m && m.mapMarker) {
              m.mapMarker.setMap(null);
            }
          });
        } else {
          element.markers.mapMarker.setMap(null);
        }
      }
      if (element.polyline) {
        if (Array.isArray(element.polyline)) {
          element.polyline.forEach(p => p.setMap(null));
        } else {
          element.polyline.setMap(null);
        }
      }
      if (element.polygon) {
        element.polygon.setMap(null);
      }
    });
  };
}, [selectedElements, map, layersVisibility, deletedMarkers]);
// Función para alternar visibilidad de capas
const toggleLayerVisibility = (layerName, layerType) => {
  const layerKey = `${layerType}-${layerName}`;
  setLayersVisibility(prev => ({
    ...prev,
    [layerKey]: !prev[layerKey] // Invertir el estado actual (undefined se considera true)
  }));
};



//metodo para limpiesa de elementos en el mapa
const handleRemoveElement = (nombre, type) => {
  setSelectedElements(prev => {
    // Primero, crear una copia filtrada del estado actual
    const updatedElements = prev.filter(el => {
      // Caso especial para buses (comparar por baseRoute)
      if (type === 'bus') {
        const baseNombre = nombre.replace(/[^0-9]/g, '');
        const elBaseNombre = el.nombre.replace(/[^0-9]/g, '');
        return !(el.type === 'bus' && elBaseNombre === baseNombre);
      }
      // Para otros tipos (puntos, polígonos), comparar por nombre exacto
      return !(el.nombre === nombre && el.type === type);
    });

    // Eliminar del mapa los elementos que coincidan
    prev.forEach(element => {
      const shouldRemove = 
        (type === 'bus' && 
         element.type === 'bus' && 
         element.nombre.replace(/[^0-9]/g, '') === nombre.replace(/[^0-9]/g, '')) ||
        (element.nombre === nombre && element.type === type);

      if (shouldRemove) {
        // Eliminar polilíneas (para buses)
        if (element.polyline) {
          if (Array.isArray(element.polyline)) {
            element.polyline.forEach(p => p.setMap(null));
          } else {
            element.polyline.setMap(null);
          }
        }
        
        // Eliminar marcadores (para puntos de interés)
        if (element.marker) {
          if (Array.isArray(element.marker)) {
            element.marker.forEach(m => m.setMap(null));
          } else {
            element.marker.setMap(null);
          }
        }
        
        // Eliminar polígonos (para formas)
        if (element.polygon) {
          element.polygon.setMap(null);
        }
      }
    });

    return updatedElements;
  });
};

  const openSaveMapPopup = () => {
  // Verificar si hay marcadores eliminados en localStorage
  const hasDeletedMarkers = localStorage.getItem('deletedMarkers') && 
                          JSON.parse(localStorage.getItem('deletedMarkers')).length > 0;

  // Solo abrir el diálogo de lista combinada si hay marcadores eliminados
  if (hasDeletedMarkers) {
    handleOpenSaveMarkersDialog();
  } else {
    // Si no hay marcadores eliminados, abrir directamente el diálogo del mapa
    setSaveMapOpen(true);
  }
};

  const closeSaveMapPopup = () => {
    setSaveMapOpen(false);
  };

  const handleSaveMap = async () => {
  try {
    // 1. Procesar los datos para guardar el mapa
    const processedData = selectedElements.map(element => {
      // Para elementos de tipo bus (líneas de autobús)
      if (element.type === 'bus') {
        return {
          nombre: element.nombre,
          type: element.type,
          data: element.data.map(point => ({
            linea: point.linea || element.nombre,
            lat: point.lat,
            lng: point.lng,
            color: point.color,
            sequence_order: point.sequence_order
          }))
        };
      }
      
      // Para otros tipos (puntos y polígonos)
      return {
        nombre: element.nombre,
        type: element.type,
        data: element.data
      };
    });

    // 2. Guardar el mapa en el backend
    const response = await axios.post('https://mapa.ne3publicidad.com.ar/api/api/saveMap', {
      name: mapName || `Mapa_${new Date().toISOString().slice(0, 10)}`,
      data: processedData
    });

    // 3. Limpieza post-guardado (asegurarse de limpiar)
    clearDeletedMarkers();

    // 4. Feedback al usuario
    setAlertMessage('Mapa guardado exitosamente');
    setAlertSeverity('success');
    setAlertOpen(true);
    
    // 5. Resetear el estado
    closeSaveMapPopup();
    setMapName('');
    setSelectedElements([]);
    setFilters({
      punto: '',
      linea: '',
      poligono: '',
    });

  } catch (error) {
    console.error('Error al guardar el mapa:', error);
    setAlertMessage(error.response?.data?.message || 'Error al guardar el mapa');
    setAlertSeverity('error');
    setAlertOpen(true);
  }
};
  
  

  

 return (
  <Box className="container" sx={{ position: 'relative' }}>
    {/* Contenedor principal de controles */}
    <Box className="main-controls">
      {/* Filtros superiores */}
      <Box className="filters-container" display="flex" justifyContent="space-between" mb={2}>
        {/* Autocomplete para Puntos de Interés */}
        <Box className="filter" id="puntos-interes-autocomplete">
          <Autocomplete
            options={[...new Set(puntosInteres.map(p => p.nombre))]} // Extrae nombres únicos
            getOptionLabel={(option) => option}
            onInputChange={(event, newValue) => setFilters({ ...filters, punto: newValue })}
            onChange={(event, newValue) => {
              if (newValue) {
                // Filtra los puntos por nombre seleccionado
                const puntosFiltrados = puntosInteres.filter(p => p.nombre === newValue);
                handleSelectElement(newValue, puntosFiltrados, 'punto');
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Capa Marcador"
                variant="outlined"
                fullWidth
              />
            )}
          />
        </Box>

        {/* Autocomplete para Polígonos */}
        <Box className="filter">
          <Autocomplete
            className="custom-autocomplete"
            options={Object.keys(poligonos).filter(nombre => 
              !selectedElements.some(el => el.nombre === nombre && el.type === 'polygon')
            )}
            getOptionLabel={(option) => option}
            onInputChange={(event, newValue) => setFilters({ ...filters, poligono: newValue })}
            onChange={(event, newValue) => {
              if (newValue) {
                handleSelectElement(newValue, poligonos[newValue], 'polygon');
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Capa Formas"
                variant="outlined"
                fullWidth
              />
            )}
          />
        </Box>
      </Box>

      {/* Buscador de direcciones  */}
      <Box id="address-search-box" className="address-search-container" sx={{ mt: 1, display: 'flex', gap: 1 }}>
        <TextField
          className="address-search-field"
          label="Direccion y localida"
          value={searchAddress}
          onChange={(e) => setSearchAddress(e.target.value)}
          fullWidth
        />
        <Button 
          id="search-address-button"
          className="custom-search-button"
          variant="contained" 
          onClick={handleSearchAddress}
        >
          Buscar y Añadir
        </Button>
      </Box>

      {/* Listas de capas marcador */}
      <Grid container spacing={2} mt={2}>
        <Grid item xs={4}>
          <Box>
            <h3>Capa Marcador</h3>
            <List>
              {selectedElements
                .filter(el => el.type === 'punto')
                .map(element => (
                  <ListItem key={element.nombre}>
                    <ListItemText primary={element.nombre} />
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      onClick={() => handleRemoveElement(element.nombre, 'punto')}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </ListItem>
                ))}
            </List>
          </Box>
        </Grid>
        
        <Grid item xs={4}>
          <Box>
            <h3>Capa Formas</h3>
            <List>
              {selectedElements
                .filter(el => el.type === 'polygon')
                .map(element => (
                  <ListItem key={element.nombre}>
                    <ListItemText primary={element.nombre} />
                    <IconButton 
                      edge="end" 
                      aria-label="delete" 
                      onClick={() => handleRemoveElement(element.nombre, 'polygon')}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </ListItem>
                ))}
            </List>
          </Box>
        </Grid>
      </Grid>
    </Box>

    <Button
  id="clear-deleted-button"
  variant="outlined"
  color="error"
  startIcon={<DeleteIcon />}
  onClick={handleClearDeletedMarkers}
  disabled={deletedMarkersCount === 0}
  className={`action-button ${deletedMarkersCount > 0 ? 'has-badge' : ''}`}
>
  Limpiar eliminados
</Button>

    {/* Botones de acción agrupados */}
    <Box className="action-buttons-container">
      <Button
        id="save-map-button"
        variant="contained"
        startIcon={<SaveIcon />}
        onClick={openSaveMapPopup}
        className="action-button"
      >
        Guardar Mapa
      </Button>

      <Button
        id="create-shape-button"
        variant="contained"
        startIcon={<img src="https://img.icons8.com/?size=100&id=Si0V2yDb01x6&format=png&color=000000" alt="Crear Forma" width="24" height="24" />}
        className={`action-button ${isDrawing ? 'drawing-active' : ''}`}
        onClick={toggleDrawing}
      >
        {isDrawing ? 'Finalizar forma' : 'Crear forma'}
      </Button>
    </Box>

    {/* Contenedor especial para mapa + acordeón */}
    <Box sx={{ position: 'relative', width: '100%' }}>
      {/* Mapa */}
      <Box id="map" className="map-container" />
      
      {/* Acordeón flotante DENTRO del mismo contenedor que el mapa */}
      <Box className="mymaps-accordion floating-accordion" id="acordion-recorrido">
        <BusCheckboxes 
          selectedElements={selectedElements} 
          handleSelectElement={handleSelectElement}
          handleRemoveElement={handleRemoveElement}
        />
      </Box>
    </Box>

    {/* Diálogos */}
    <Dialog open={saveMapOpen} onClose={closeSaveMapPopup}>
      <DialogTitle>Guardar Mapa</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Nombre del Mapa"
          fullWidth
          value={mapName}
          onChange={(e) => setMapName(e.target.value)}
        />
        
        {temporalMarkers.length > 0 && (
          <>
            <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
              Tienes {temporalMarkers.length} marcadores temporales que no han sido guardados.
            </Typography>
            <TextField
              margin="dense"
              label="Nombre para los marcadores"
              fullWidth
              value={newListName}
              onChange={(e) => setNewListName(e.target.value)}
              sx={{ mt: 2 }}
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={closeSaveMapPopup}>Cancelar</Button>
        <Button onClick={() => {
          if (temporalMarkers.length > 0) {
            handleSaveTemporalMarkers().then(handleSaveMap);
          } else {
            handleSaveMap();
          }
        }}>Guardar</Button>
      </DialogActions>
    </Dialog>

    {/* Diálogo para confirmar marcador de dirección */}
    <Dialog open={addressDialogOpen} onClose={() => setAddressDialogOpen(false)}>
      <DialogTitle>Confirmar Marcador</DialogTitle>
      <DialogContent>
        <Typography>Dirección: {foundLocation?.direccion}</Typography>
        <Typography>Localidad: {foundLocation?.localidad}</Typography>
        <Typography>Coordenadas: {foundLocation?.lat}, {foundLocation?.lng}</Typography>
        {icono && <img src={icono} alt="Ícono seleccionado" width="32" height="32" />}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setAddressDialogOpen(false)}>Cancelar</Button>
        <Button 
          onClick={handleAddTemporalMarker}
          disabled={!icono}
        >
          Añadir Marcador
        </Button>
      </DialogActions>
    </Dialog>

    <Snackbar open={alertOpen} autoHideDuration={6000} onClose={() => setAlertOpen(false)}>
      <Alert onClose={() => setAlertOpen(false)} severity={alertSeverity} sx={{ width: '100%' }}>
        {alertMessage}
      </Alert>
    </Snackbar>

    {/* Diálogo de selección de íconos - VERSIÓN ACTUALIZADA */}
    <Dialog open={iconDialogOpen} onClose={() => {
      setIconDialogOpen(false);
      setMarkerToEdit(null);
    }}>
      <DialogTitle>Seleccionar Ícono para Marcador</DialogTitle>
      <DialogContent>
        {markerToEdit && (
          <Box mb={2}>
            <Typography variant="subtitle1">Ubicación:</Typography>
            <Typography variant="body2">{markerToEdit.direccion}</Typography>
            <Typography variant="body2">Coordenadas: {markerToEdit.lat?.toFixed(6)}, {markerToEdit.lng?.toFixed(6)}</Typography>
          </Box>
        )}
        <IconSelector onSelectIcon={handleSelectIcon} />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {
          setIconDialogOpen(false);
          setMarkerToEdit(null);
        }}>Cancelar</Button>
      </DialogActions>
    </Dialog>

    <Dialog open={pointDialogOpen} onClose={() => setPointDialogOpen(false)}>
      <DialogTitle>Agregar Capa Marcador</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Nombre del Punto"
          fullWidth
          value={pointName}
          onChange={(e) => setPointName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setPointDialogOpen(false)}>Cancelar</Button>
        <Button onClick={handleAddPoint}>Aceptar</Button>
      </DialogActions>
    </Dialog>

    <Dialog open={polygonDialogOpen} onClose={handleCancelPolygon}>
      <DialogTitle>Guardar Capa Forma</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Nombre de la Forma"
          fullWidth
          value={nombreZona}
          onChange={(e) => setNombreZona(e.target.value)}
        />
        <ColorPicker
          selectedColor={selectedColor}
          onChange={(color) => setSelectedColor(color)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancelPolygon}>Cancelar</Button>
        <Button onClick={handleSavePolygon}>Guardar</Button>
      </DialogActions>
    </Dialog>

    <Dialog open={saveMarkersDialogOpen} onClose={() => setSaveMarkersDialogOpen(false)}>
      <DialogTitle>Guardar nueva lista</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Nombre de la nueva lista"
          fullWidth
          value={newListName}
          onChange={(e) => setNewListName(e.target.value)}
        />
        <Typography variant="body2" sx={{ mt: 2 }}>
          {combinedMarkers.length} marcadores serán guardados.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setSaveMarkersDialogOpen(false)}>Cancelar</Button>
        <Button onClick={handleSaveCombinedMarkers}>Guardar</Button>
      </DialogActions>
    </Dialog>
  </Box>
);
  
};
export default Mymaps;